import { getOffset } from '../../Utils/utils'

export const graphRh = () => {
  const headerHeight = document.querySelector('header .header_fix').offsetHeight
  const windowHeight = window.innerHeight
  const graphs = document.querySelectorAll('.graph_rh_component')
  if (graphs?.length) {
    document.addEventListener('scroll', () => {
      graphs.forEach((graph) => {
        const graphOffsetTop = getOffset(graph)
        if (graphOffsetTop.top - windowHeight / 2 < window.pageYOffset) {
          graph.querySelector('svg')?.classList.add('active')
        }
      })
    })
  }
}
